import React from 'react';//React builds the UI components  

import ReactDOM from 'react-dom';//ReactDOM puts them into the web browser
import { Router } from "react-router-dom";//Router` is used to **handle page navigation** in a React app — like going to Home, About, Contact pages **without reloading** the page.
import { createBrowserHistory } from "history";//history` keeps a **record of visited pages** in your app.  `createBrowserHistory()` lets you **control and use** that record.

import App from './App';
import * as serviceWorker from './serviceWorker';

//import './App.css';
import './assets/scss/style.scss';

const history = createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById('root')
);//This line makes your **React app appear on the web page** and sets up navigation so you can change screens within the app.


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
